import z from "zod";

/**
 * Ссылка на файл, который используется в пределах MDM-системы
 */

export const zMdmFile = z.object({
  id: z.string(),
  name: z.string(),
  size: z.number().nullish(),
  mime: z.string().nullish(),
});

export type ZMdmFile = z.infer<typeof zMdmFile>;

export const zMdmFileEd = zMdmFile.extend({
  errorMsg: z.string().optional(),
});

export type ZMdmFileEd = z.infer<typeof zMdmFileEd>;
